export default "__VITE_ASSET__BOXeXaLB__"